import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { isExternal } from "../utils/url"

export interface LinkProps {
  url: string
  openInNewTab?: boolean
  light?: boolean
  id?: string
  children: React.ReactNode
}

const Link = (props: LinkProps) => {
  const targetProps = props.openInNewTab
    ? {
        target: "_blank",
        rel: "noreferrer",
      }
    : null

  const classes = `c-link ${props.light ? `-light` : ``}`

  return isExternal(props.url) ? (
    <a
      target="_blank"
      rel="noreferrer"
      className={classes}
      href={props.url}
      id={props.id}
      {...targetProps}
    >
      {props.children}
    </a>
  ) : (
    <GatsbyLink className={classes} to={props.url} id={props.id}>
      {props.children}
    </GatsbyLink>
  )
}

export default Link
